export default {
  'measurement.tons': '{weight} tons',
  'measurement.height': 'height',
  'measurement.length': 'length',
  'measurement.width': 'width',
};
